module.exports = __webpack_public_path__ + "website/img/loading.f8a6d83f.gif";